export default __webpack_public_path__ + "static/media/directory.f5efb421.png";